module.exports = __webpack_public_path__ + "img/Sib_Mus_1kl.a7766f98.jpg";